(ns ui.sticker-dialogs.storage
  "Reads and writes the recent lists of the sticker dialogs in the
   `storrito:editor2:recent` localStorage entry (`ui.editor2.recent`),
   with the pure list logic of `ui.sticker-dialogs.recent`."
  (:require [ui.editor2.recent :as editor2.recent]
            [ui.sticker-dialogs.recent :as recent]))

(defn now
  []
  (.now js/Date))

(defn recent-hashtags
  []
  (recent/sorted-hashtags (:hashtags (editor2.recent/read-editor2-recent))))

(defn remember-hashtags!
  [hashtags]
  (editor2.recent/write-editor2-recent!
    (update (editor2.recent/read-editor2-recent)
            :hashtags
            recent/remember-hashtags
            hashtags
            (now))))

(defn forget-hashtag!
  [entry]
  (editor2.recent/write-editor2-recent!
    (update (editor2.recent/read-editor2-recent)
            :hashtags
            recent/remove-by-key
            recent/hashtag-key
            (recent/hashtag-key entry))))

(defn recent-mentions
  []
  (recent/sorted-mentions (:mentions (editor2.recent/read-editor2-recent))))

(defn find-mention
  "The cached validation result for `username`, if it was validated
   before."
  [username]
  (recent/find-mention (:mentions (editor2.recent/read-editor2-recent))
                       username))

(defn remember-mention!
  [result]
  (editor2.recent/write-editor2-recent!
    (update (editor2.recent/read-editor2-recent)
            :mentions
            recent/remember-mention
            result
            (now))))

(defn forget-mention!
  [entry]
  (editor2.recent/write-editor2-recent!
    (update (editor2.recent/read-editor2-recent)
            :mentions
            recent/remove-mention
            entry)))

(defn recent-locations
  []
  (recent/sorted-locations (:locations (editor2.recent/read-editor2-recent))))

(defn remember-location!
  [location]
  (editor2.recent/write-editor2-recent!
    (update (editor2.recent/read-editor2-recent)
            :locations
            recent/remember-location
            location
            (now))))

(defn forget-location!
  [location]
  (editor2.recent/write-editor2-recent!
    (update (editor2.recent/read-editor2-recent)
            :locations
            recent/remove-by-key
            recent/location-key
            (recent/location-key location))))
